// extracted by mini-css-extract-plugin
export default {"root":"JPlaceHeader_root__ZyaYw","deleteLink":"JPlaceHeader_deleteLink__c+r-U","placeHolderShimmer":"JPlaceHeader_placeHolderShimmer__SrSiE"};